import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ITicket, ITicketRequest } from "../types/Types";
import { ErrorAPI } from "./ErrorAPI";

/**
 * @author mb
 */
const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "ticket",
    credentials: 'include'
});

const baseQueryWithErrorHandling = async (args: any, api: any, extraOptions: any) => {
    const result = await baseQuery(args, api, extraOptions);

    if (result.error) {
        const errorMessage = (result.error?.data as any)?.text || (result.error?.data as any)?.message || 'Unknown error';
        const status = (result.error as any)?.status || 'UNKNOWN';

        // Log error via ErrorAPI
        try {
            await api.dispatch(ErrorAPI.endpoints.createLog.initiate({
                status: String(status),
                api: "ticket",
                message: errorMessage
            }));
        } catch (logError) {
            console.error('Failed to log error:', logError);
        }
    }
    return result;
};
export const TicketAPI = createApi({
    reducerPath: "ticketAPI",
    baseQuery: baseQueryWithErrorHandling,
    tagTypes: ['ticketAPI'], // for caching
    endpoints: (builder) => ({
        getTicketListe: builder.mutation<ITicket[], void>(
            {
                query: () => ({
                    url: '/',
                    method: 'get',
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        getTicket: builder.mutation<any, string>(
            {
                query: (uid) => ({
                    url: '/' + uid,
                    method: 'get',
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        createOrUpdateTicket: builder.mutation<ITicket, ITicketRequest>(
            {
                query: (dto: ITicketRequest) => ({
                    url: 'createOrUpdate',
                    method: 'put',
                    credentials: 'include',
                    body: dto
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        deleteTicket: builder.mutation<ITicket, string>(
            {
                query: (uid) => ({
                    url: '' + uid,
                    method: 'delete',
                    params: {
                    },
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        getTicketNachrichten: builder.mutation<any, string>(
            {
                query: (uid) => ({
                    url: '/' + uid + "/nachrichten/",
                    method: 'get',
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        newTicketNachricht: builder.mutation<string, { uid: string, text: string }>(
            {
                query: (dto) => ({
                    url: '/' + dto.uid + '/nachrichten/',
                    method: 'put',
                    body: dto.text,
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),

    })
});

export const {

    useGetTicketListeMutation,
    useCreateOrUpdateTicketMutation,
    useGetTicketMutation,
    useDeleteTicketMutation,
    useGetTicketNachrichtenMutation,
    useNewTicketNachrichtMutation,

} = TicketAPI;
